var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherExpenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Finance",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Finance_Initial-(Desktop)",
    transform: "translate(-875.000000, -657.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(845.000000, 297.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transactions_OtherExpenses",
    transform: "translate(30.000000, 360.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    stroke: "transparent",
    mask: "url(#mask-2)",
    strokeWidth: 1.6,
    strokeDasharray: "0,0",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.699999988,
    transform: "translate(5.000000, 5.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7112412,13.4422058 C19.663826,13.1102995 19.4504577,12.8258084 19.142259,12.6835628 L18.2413704,12.2805337 L19.4030425,11.2611072 C19.663826,11.0477388 19.782364,10.7158325 19.7349488,10.3602186 C19.6875336,10.0283123 19.4741653,9.74382114 19.1659666,9.60157557 L14.7563541,7.70496805 C15.0882604,7.01744783 15.2779211,6.23509722 15.2779211,5.40533143 C15.2779211,2.41817459 12.8597465,0 9.8725897,0 C6.88543286,0 4.46725827,2.41817459 4.46725827,5.40533143 C4.46725827,5.50016181 4.46725827,5.61869978 4.49096586,5.71353016 L0.365844506,9.31708444 C0.105060972,9.53045279 -0.0134769982,9.86235911 0.0339381898,10.217973 C0.0813533779,10.5498793 0.294721724,10.8343705 0.602920446,10.976616 L1.50380902,11.3796451 L0.342136912,12.3990717 C0.0813533779,12.61244 -0.0371845922,12.9443463 0.0102305958,13.2999602 C0.0576457838,13.6318666 0.27101413,13.9163577 0.579212852,14.0586032 L1.48010142,14.4616323 L12.6937934,19.4985067 C12.8123314,19.5459219 12.9545769,19.5933371 13.0968225,19.5933371 C13.3338984,19.5933371 13.5709744,19.4985067 13.7606351,19.3562611 L18.2176628,15.4099361 L19.3793349,14.3905096 C19.6401184,14.1060184 19.7586564,13.7741121 19.7112412,13.4422058 Z M9.8725897,1.04313414 C12.2907643,1.04313414 14.2584946,3.01086444 14.2584946,5.42903903 C14.2584946,7.84721362 12.2907643,9.79123633 9.8725897,9.79123633 C7.45441511,9.79123633 5.48668481,7.82350602 5.48668481,5.40533143 C5.48668481,2.98715684 7.45441511,1.04313414 9.8725897,1.04313414 Z M1.10077992,10.0520199 L4.68062662,6.89890986 C5.32073165,9.15113129 7.40699993,10.8106629 9.8725897,10.8106629 C11.6506593,10.8106629 13.2390681,9.93348189 14.234787,8.58214903 L18.6443995,10.5498793 L13.1442377,15.3625209 L1.10077992,10.0520199 Z M13.1442377,18.4208005 L1.10077992,13.1102995 L2.54694315,11.8300894 L12.7412086,16.3345323 C12.8597465,16.3819475 13.0019921,16.4293626 13.1442377,16.4293626 C13.3813136,16.4293626 13.6183896,16.3345323 13.7843427,16.1922867 L17.3641894,13.0628843 L18.6443995,13.6318666 L13.1442377,18.4208005 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2282036,6.94632504 L9.51697579,6.94632504 C9.23248466,6.94632504 9.01911632,6.7092491 9.01911632,6.44846557 L7.97598218,6.44846557 C7.97598218,7.23081617 8.59237963,7.8946288 9.35102263,7.96575159 L9.35102263,8.72439459 L10.3941568,8.72439459 L10.3941568,7.96575159 C11.1765074,7.8946288 11.7691972,7.23081617 11.7691972,6.44846557 C11.7691972,5.59499219 11.081677,4.90747196 10.2282036,4.90747196 L9.51697579,4.90747196 C9.23248466,4.90747196 9.01911632,4.67039602 9.01911632,4.40961249 C9.01911632,4.12512136 9.25619226,3.91175301 9.51697579,3.91175301 L10.2282036,3.91175301 C10.5126947,3.91175301 10.7260631,4.14882895 10.7260631,4.40961249 L11.7691972,4.40961249 C11.7691972,3.62726188 11.1527998,2.96344925 10.3941568,2.89232647 L10.3941568,2.13368346 L9.35102263,2.13368346 L9.35102263,2.89232647 C8.59237963,2.93974166 7.97598218,3.60355429 7.97598218,4.38590489 C7.97598218,5.23937828 8.66350241,5.9268985 9.51697579,5.9268985 L10.2282036,5.9268985 C10.5126947,5.9268985 10.7260631,6.16397444 10.7260631,6.42475798 C10.7260631,6.7092491 10.5126947,6.94632504 10.2282036,6.94632504 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherExpenses);
export default __webpack_public_path__ + "static/media/other-expenses.b77031a5e49b831c0e9c510899dbfe80.svg";
export { ForwardRef as ReactComponent };